module.exports = __webpack_public_path__ + "static/media/level3-2.bcce24ba.mp3";